// extracted by mini-css-extract-plugin
export default {"container":"Card_container__7c0rY","content":"Card_content__mXrWW","title":"Card_title__VjT60","svg-container":"Card_svg-container__PRkIi","text":"Card_text__nMTBM"};